<template>
	<div class="route-info-content">
		<el-dialog
			title="基本信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			:modal="false"
			custom-class="route-info-dialog"
			width="580px"
			:before-close="beforeDialogClose"
			ref="dialog"
			:top="top"
		>
			<span slot="title" class="flex flex-middle">
				<div class="title">
					无位置客商列表
					<span class="color-red">（可点击路线名前往路线编辑页面采集位置信息）</span>
				</div>
			</span>
            <el-table
				border
				:height="tableHeight"
				:data="shopList"
				:header-cell-style="{
					background: 'rgba(200, 204, 215,.6)',
					color: '#333333'
				}"
			>
				<el-table-column prop="agentName" label="客商简称" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="sapAgentNo" label="SAP编号" width="100" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="" label="当前路线" width="100" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p class="cursor-pointer" @click="handleEditRoute(scope.row)">{{ scope.row.routeName }}</p>
						<img v-if="!scope.row.routeName" class="cursor-pointer width24" src="@/assets/images/map_0.png" @click="handlePoint(scope.row)">
					</template>
				</el-table-column>
				<el-table-column prop="channelName" width="60" label="渠道" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="allSku" width="60" label="累计" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="allDaver" width="60" label="日均" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
		</el-dialog>
		<editPoint ref="editPoint" @setList="setList"></editPoint>
	</div>
</template>
<script>
import editPoint from "./edit-point.vue"
export default {
	components: {
		editPoint
	},
	data() {
		return {
			dialogVisible: false,
            // 无位置店铺
			shopList: [],
			// 离顶位置
			top: '117px',
			// 表格高度
			tableHeight: 798
		};
	},
	methods: {
		init(shopList) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.top = window.innerWidth > 1730 ? '98px' : '138px';
				this.tableHeight = window.innerWidth > 1730 ? window.innerHeight - 172 : window.innerHeight - 212;
				this.shopList = shopList;
			});
		},
		// 关闭动画
		beforeDialogClose(done) {
			this.$refs.dialog.$el.classList.add('dialog-close-animation');
			setTimeout(() => {
				// 动画完成后调用 done 函数关闭对话框
				done();
			}, 700);
		},
		// 调用编辑路线
		handleEditRoute(row) {
			this.$emit('handleEditRoute',row);
		},
		// 点击地图取点
		handlePoint(agent) {
			agent.type = 'notposition';
			this.$refs.editPoint.init(agent);
		},
		// 去除选点的数据
		setList(shop) {
			this.shopList = this.shopList.filter(agent => agent.agentId != shop.agentId);
		},
		// 关闭
		handleClose() {
			this.dialogVisible = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.route-info-content /deep/ .el-dialog__body {
	padding: 0;
}
.route-info-content /deep/ .el-table .cell,
.route-info-content /deep/ .el-table .el-table__cell,
.route-info-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 1px 5px;
	line-height: 30px;
}

.cursor-pointer{
	cursor: pointer;
}

.color-red{
	color: red;
}

.width24{
	width: 28px;
	vertical-align: middle;
}
</style>
<style>
.route-info-dialog{
	position: absolute;
	right: 0;
	animation: anim-open .8s ease !important;
}
@keyframes anim-open {
    0% {
        right: -820px;
    }

    100% {
        right: 0;
    }
}
.dialog-close-animation{
	animation: anim-close .8s ease !important;
}
@keyframes anim-close {
    0% {
        right: 0;
    }

    100% {
        right: -820px;
    }
}
/* 去除遮罩层，可点击下层元素 */
.el-dialog__wrapper{
    pointer-events: none;
}
.el-dialog{
    pointer-events: auto;
}
</style>
